<template>
    <rkm-overlay>
        <rkm-layout-body title="Procedimentos">
            <template v-slot:actions>
                <rkm-button
                    @click="handleExit"
                    color="danger"
                >
                    Sair
                </rkm-button>

                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    :id="$route.params.id"
                    :pacienteId="parseInt($route.params.pacienteId)"
                    @save="handleSave"
                    @exit="handleExit"
                    @redirect="redirect"
                    ref="Form"
                />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>

// Components.
import Form from "@/components/atencao-basica/procedimento/Form";

// Vuex.
import { mapActions } from 'vuex';

// Mixins
import { repository, error, object, data } from '@/mixins'

export default {
    components: { Form },
    created() {

        this.setShowExitFormConfirmation()

        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.atencaoBasica')
        }
    },
    data: () => ({
        cadastro: false,
    }),
    methods: {
        ...mapActions([
            'setShowExitFormConfirmation',
            'unsetShowExitFormConfirmation',
        ]),
        handleExit() {
            this.$router.push({ name: 'atencao-basica-procedimento' })
        },
        handleSave() {
            this.unsetShowExitFormConfirmation()
            this.handleExit()
        },
        redirect(id) {

            this.unsetShowExitFormConfirmation()
            this.$router.push({ name: 'atencao-basica-procedimento-edit', params: { id: id } })
        },
    },
    mixins: [repository, error, object, data],
}
</script>